import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AddWellComponent } from 'src/app/components/add-well/add-well.component';
import { SPECIAL_CHAR_REGEX, SPECIAL_CHAR_REGEX_MSG } from 'src/app/shared/constants/global-constants';
import { CustomValidators } from 'src/app/shared/helpers/custom-validator';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Organization } from 'src/app/shared/models/organization.model';

@Component({
  selector: 'ple-download-modal',
  templateUrl: './downloadType-modal.component.html',
  styleUrls: ['./downloadType-modal.component.scss']
})
export class DownloadTypeModalComponent implements OnInit {

  downloadDataType: string;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data:any,
    public dialogRef: MatDialogRef<DownloadTypeModalComponent>
  ) {}

  ngOnInit(): void {
    this.downloadDataType = 'csv';
   
  }

  download() {
    this.dialogRef.close(this.downloadDataType);
  }
}
